import MatrixBG from "./MatrixBG";

function App() {
  return (
    <div style={{ position: "relative", width: "100vw", height: "100vh" }}>
      <MatrixBG />
    </div>
  );
}

export default App;
